import { initializeApp } from 'firebase/app';
import { getAuth, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBvzyg1t4MRwZz6NxcYq1nokQ1omV6kzZg",
  authDomain: "mercy-94d99.firebaseapp.com",
  projectId: "mercy-94d99",
  storageBucket: "mercy-94d99.firebasestorage.app",
  messagingSenderId: "540403723510",
  appId: "1:540403723510:web:d4631f25be1e4e031150d7",
  measurementId: "G-WGFF9M8EDN"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

const ACTION_CODE_SETTINGS = {
  url: process.env.REACT_APP_MAGIC_LINK_URL || 'https://mercyapp.vercel.app',
  handleCodeInApp: true,
};

export async function sendMagicLink(email) {
  await sendSignInLinkToEmail(auth, email, ACTION_CODE_SETTINGS);
  window.localStorage.setItem('mercyEmailForSignIn', email);
}

export function checkIsMagicLink() {
  return isSignInWithEmailLink(auth, window.location.href);
}

export async function completeMagicLink() {
  let email = window.localStorage.getItem('mercyEmailForSignIn');
  if (!email) {
    email = window.prompt('Please enter your email to confirm sign-in:');
  }
  const result = await signInWithEmailLink(auth, email, window.location.href);
  window.localStorage.removeItem('mercyEmailForSignIn');
  window.history.replaceState(null, '', window.location.pathname);
  return result.user;
}

export default app;
